/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import VModal from 'vue-js-modal';
import router from './router';
import Vuex from "vuex";
import 'prismjs'
import 'prismjs/themes/prism.css'

Vue.use(VModal, {dialog: true});


require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const store = new Vuex.Store({
    state: {
        search: '',
        searchLoading: false
    },
    mutations: {
        search(state, payload) {
            state.search = payload;
        },
        setSearchLoading(state, value) {
            state.searchLoading = value;
        }
    }
});

const app = new Vue({
    el: '#app',
    store,
    router,
    data: {
        searchValue: '',
        loading:false
    },
    methods: {
        async submitSearch() {
            await this.$store.commit("setSearchLoading", true);
            await this.$store.commit("search", this.searchValue);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/js/app.js